import * as keyapis_user_v1_system_pb from "./v1/keyapis_user_system_v1.pb";
import * as keyapis_user_v1_user_pb from "./v1/keyapis_user_user_v1.pb";

export default {
  v1: {
    resources: {
      system: keyapis_user_v1_system_pb,
      user: keyapis_user_v1_user_pb,
    },
  },
};
